import { AppDetail } from "../../../utils/interfaces/background.interface";

export const apps: Map<string, AppDetail> = new Map<string, AppDetail>();

apps.set('ERNI', {
  isTemplate: true,
  template: {
    colorPalette: {
      information: {
        backgroundColor: '#05BE50',
        titleColor: '#ffffff',
        descriptionColor: '#ffffff',
        instruction: {
          questionColor: '#049840',
          answerColor: '#666666',
          statementColor: '#333333'
        }
      },
      login: {
        iconColor: '#05BE50',
        statementColor: '#0F191E'
      },
    },
    information: {
      logoUrl: 'https://resources.interfondos.com.pe/opibk/Erni_logo_blanco.svg',
      title: 'Inicia sesión en la Banca por Internet de Interbank',
      description: 'para continuar con tu operación de Fondos Mutuos',
      instruction: {
        question: '¿Por qué hago esto?',
        answer: 'Al iniciar sesión en la Banca por Internet de Interbank, nos permites autorizar que tu solicitud de aporte en tu fondo mutuo se cargue de la cuenta de ahorros que elegiste.',
        statement: 'Este proceso es 100% seguro.'
      },
      imageUrl: 'https://resources.interfondos.com.pe/opibk/Erni_Imagen_OP_IBK.svg',
      secondaryLogoUrl: 'https://resources.interfondos.com.pe/opibk/Interfondos_logo_blanco_1.svg',
    },
    login: {
      icon: 'privacy_tip',
      statement: 'Necesitamos que inicies sesión en <b>Interbank</b> y asi el banco nos permita autorizar el movimiento que realizarás por Erni.',
    }
  }
});

apps.set('test2App', {
  isTemplate: false,
  background: {
    image: 'https://www.peru.travel/Contenido/Noticia/Imagen/pe/1441/1.0/Principal/rio-amazonas-10-a%C3%B1os.jpg'
  },
});

apps.set('default', {
  isTemplate: false,
  background: {
    image: 'https://bpi.azureedge.net/assets-1-0-0/images/login/bpi_bg_lg.jpg?IjgadmAs='
  },
});
